<template>
	<td v-bind="attributes"><input v-if="rowContext.itemKey" type="checkbox" v-model="state"></td>
</template>

<script setup lang="ts">
import {cellStyle, rowContextKey} from "./AgendaUtils";
import {computed, type CSSProperties, inject} from "vue";
import {injectSelection, type RowSelection} from "./RowSelection";
import {Column} from "@t/agenda/Columns.ts";

const props = withDefaults(defineProps<{
	object: object,
	col: Column
}>(), { });

//const ag = injectItemsGrid();
const sel:RowSelection = injectSelection();
const rowContext = inject(rowContextKey);
const attributes = computed(() => {
	return { style: cellStyle(props.col) }
});

const state = computed<boolean>({
	get():boolean {
		return sel.get(rowContext.value.itemKey);
	},
	set(v:boolean):void {
		sel.set(rowContext.value.itemKey, v);
	}
});

</script>

<style>

</style>
